import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, createBlock as _createBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  class: "FiltersBarMobile MobileOnly",
  ref: "filtersBarMobile"
}
const _hoisted_2 = { class: "SearchSummaryMobile" }
const _hoisted_3 = { class: "FiltersBarButtonsMobile" }
const _hoisted_4 = {
  key: 0,
  class: "Badge"
}
const _hoisted_5 = {
  class: "FloatingFiltersButtonMobileWrapper",
  ref: "floatingFiltersButtonMobileWrapper"
}
const _hoisted_6 = {
  key: 0,
  class: "Badge"
}
const _hoisted_7 = { class: "SortBarDesktop DesktopOnly" }
const _hoisted_8 = { class: "SearchSummaryDesktop" }
const _hoisted_9 = { class: "Hidden" }
const _hoisted_10 = { ref: "modalContent" }
const _hoisted_11 = { class: "ModalLabel" }
const _hoisted_12 = { class: "ShowResultsButtonContainer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Sort = _resolveComponent("Sort")!
  const _component_FilterContainer = _resolveComponent("FilterContainer")!
  const _component_SortContainer = _resolveComponent("SortContainer")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("span", _hoisted_2, "Page " + _toDisplayString(_ctx.currentPageNumber) + " | " + _toDisplayString(_ctx.totalSearchResults) + " " + _toDisplayString(_ctx.resultsLabel), 1 /* TEXT */),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("button", {
          class: "SortButtonMobile",
          type: "button",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.openModal('sort')))
        }, [...(_cache[7] || (_cache[7] = [
          _createElementVNode("i", { class: "lnr-sort-amount-asc" }, null, -1 /* CACHED */)
        ]))]),
        _createElementVNode("button", {
          class: "FiltersButtonMobile",
          type: "button",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.openModal('filter')))
        }, [
          _cache[8] || (_cache[8] = _createElementVNode("i", { class: "lnr-equalizer" }, null, -1 /* CACHED */)),
          _cache[9] || (_cache[9] = _createTextVNode(" Filters ", -1 /* CACHED */)),
          (_ctx.filterHintCount > 0)
            ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(_ctx.filterHintCount), 1 /* TEXT */))
            : _createCommentVNode("v-if", true)
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("button", {
            class: "FloatingFiltersButtonMobile",
            type: "button",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.openModal('filter')))
          }, [
            _cache[10] || (_cache[10] = _createElementVNode("i", { class: "lnr-equalizer" }, null, -1 /* CACHED */)),
            _cache[11] || (_cache[11] = _createTextVNode(" Filters ", -1 /* CACHED */)),
            (_ctx.filterHintCount > 0)
              ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(_ctx.filterHintCount), 1 /* TEXT */))
              : _createCommentVNode("v-if", true)
          ])
        ], 512 /* NEED_PATCH */)
      ])
    ], 512 /* NEED_PATCH */),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.totalSearchResults) + " " + _toDisplayString(_ctx.resultsLabel), 1 /* TEXT */),
      _createVNode(_component_Sort)
    ]),
    _createElementVNode("div", _hoisted_9, [
      _createElementVNode("aside", _hoisted_10, [
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("button", {
            type: "button",
            class: _normalizeClass(["ModalLabelButton", { Active: _ctx.shouldShowFilters }]),
            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.showFiltersInModal()))
          }, [...(_cache[12] || (_cache[12] = [
            _createElementVNode("i", { class: "lnr-equalizer ModalLabelButtonIcon" }, null, -1 /* CACHED */),
            _createTextVNode(" Filters ", -1 /* CACHED */)
          ]))], 2 /* CLASS */),
          _createElementVNode("button", {
            type: "button",
            class: _normalizeClass(["ModalLabelButton", { Active: !_ctx.shouldShowFilters }]),
            onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.showSortInModal()))
          }, [...(_cache[13] || (_cache[13] = [
            _createElementVNode("i", { class: "lnr-sort-amount-asc ModalLabelButtonIcon" }, null, -1 /* CACHED */),
            _createTextVNode(" Sort ", -1 /* CACHED */)
          ]))], 2 /* CLASS */)
        ]),
        (_ctx.modalShowContent && _ctx.shouldShowFilters)
          ? (_openBlock(), _createBlock(_component_FilterContainer, { key: 0 }))
          : _createCommentVNode("v-if", true),
        (_ctx.modalShowContent && !_ctx.shouldShowFilters)
          ? (_openBlock(), _createBlock(_component_SortContainer, { key: 1 }))
          : _createCommentVNode("v-if", true),
        _createElementVNode("div", _hoisted_12, [
          (_ctx.isApplicationStatusNotReady)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                class: "ShowResults",
                type: "button",
                onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.closeModal()))
              }, "Show results"))
            : (_openBlock(), _createElementBlock("button", {
                key: 1,
                class: "ShowResults",
                type: "button",
                onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.closeModal()))
              }, "Show " + _toDisplayString(_ctx.totalSearchResults) + " results", 1 /* TEXT */))
        ])
      ], 512 /* NEED_PATCH */)
    ])
  ], 64 /* STABLE_FRAGMENT */))
}